import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// 註冊 Service Worker (PWA 支援)
serviceWorkerRegistration.register({
  onSuccess: () => {
    console.log('Service Worker 註冊成功');
  }
});

